import React from "react";

export default function AboutUs() {
  return (
    <div className="about-us">
      <div className="container">
        {/* Section Title */}
        <div className="row section-row align-items-center">
          <div className="col-lg-8">
            <div className="section-title">
              <h3
                className="wow fadeInUp"
                style={{ visibility: "visible", animationName: "fadeInUp" }}
              >
                About Company
              </h3>

              <h2 className="text-anime-style-3" style={{ perspective: "400px" }}>
                <div className="split-line">
                  <span>HealthTech at a glance</span>
                </div>
              </h2>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="row align-items-center">
          {/* Image */}
          <div className="col-lg-6">
            <div className="about-image">
              <div className="about-img">
                <figure
                  className="image-anime reveal"
                  style={{
                    transform: "translate(0px, 0px)",
                    opacity: 1,
                    visibility: "inherit",
                  }}
                >
                  <img
                    src="./assets/images/about-us-img.jpg"
                    alt="About Us"
                    style={{ transform: "translate(0px, 0px)" }}
                  />
                </figure>
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="col-lg-6">
            <div className="about-content">
              <p
                className="wow fadeInUp"
                data-wow-delay="0.25s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.25s",
                  animationName: "fadeInUp",
                }}
              >
                Founded in 2025, HealthTech Solutions delivers trusted, innovative
                solutions across the health, pharmaceutical, life sciences, and
                digital technology sectors.
              </p>

              <p
                className="wow fadeInUp"
                data-wow-delay="0.25s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.25s",
                  animationName: "fadeInUp",
                }}
              >
                We help businesses transform, grow, and stay future-ready through
                advanced IT solutions, digital marketing, automation, and
                strategic consulting.
              </p>

              <p
                className="wow fadeInUp"
                data-wow-delay="0.25s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.25s",
                  animationName: "fadeInUp",
                }}
              >
                At HealthTech Solutions, we don’t just deliver services — we
                partner with organizations to build smarter, connected, and
                future-driven digital experiences.
              </p>

              <a
                href="/about-us"
                className="btn-default wow fadeInUp"
                data-wow-delay="1.25s"
                style={{
                  visibility: "visible",
                  animationDelay: "1.25s",
                  animationName: "fadeInUp",
                }}
              >
                More Details
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
